/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerUserInvitationRemoveResult {
  Success = 0,
  Error = 1,
  InvitationNotFound = 2,
  InvitationCompleted = 3,
  InvalidCompany = 4,
}
